/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValueDefaults } from './ValueDefaults';
import {
    ValueDefaultsFromJSON,
    ValueDefaultsFromJSONTyped,
    ValueDefaultsToJSON,
} from './ValueDefaults';

/**
 * 
 * @export
 * @interface IntegrationWriteObject
 */
export interface IntegrationWriteObject {
    /**
     * 
     * @type {string}
     * @memberof IntegrationWriteObject
     */
    objectName: string;
    /**
     * If true, the write object will inherit the mapping from the read object. If false, the write object will have no mapping.
     * @type {boolean}
     * @memberof IntegrationWriteObject
     */
    inheritMapping?: boolean;
    /**
     * 
     * @type {ValueDefaults}
     * @memberof IntegrationWriteObject
     */
    valueDefaults?: ValueDefaults;
}

/**
 * Check if a given object implements the IntegrationWriteObject interface.
 */
export function instanceOfIntegrationWriteObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectName" in value;

    return isInstance;
}

export function IntegrationWriteObjectFromJSON(json: any): IntegrationWriteObject {
    return IntegrationWriteObjectFromJSONTyped(json, false);
}

export function IntegrationWriteObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationWriteObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectName': json['objectName'],
        'inheritMapping': !exists(json, 'inheritMapping') ? undefined : json['inheritMapping'],
        'valueDefaults': !exists(json, 'valueDefaults') ? undefined : ValueDefaultsFromJSON(json['valueDefaults']),
    };
}

export function IntegrationWriteObjectToJSON(value?: IntegrationWriteObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objectName': value.objectName,
        'inheritMapping': value.inheritMapping,
        'valueDefaults': ValueDefaultsToJSON(value.valueDefaults),
    };
}

